import { render } from "./MyBalance.vue?vue&type=template&id=efef0262&scoped=true"
import script from "./MyBalance.vue?vue&type=script&lang=js"
export * from "./MyBalance.vue?vue&type=script&lang=js"

import "./MyBalance.vue?vue&type=style&index=0&id=efef0262&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efef0262"]])

export default __exports__